// extracted by mini-css-extract-plugin
module.exports = {"container":"Retailers_container__TxFsK"};